import React from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/system";

const AutobiaRadio = ({
  value,
  onChange,
  options,
  label,
  disabled = false,
  error = false,
  helperText,
  color = "primary",
  size = "medium",
  row = false,
}) => {
  const theme = useTheme();

  return (
    <FormControl error={error} disabled={disabled} sx={{ width: "100%" }}>
      {label && (
        <FormLabel
          sx={{
            color: theme.palette.gray.g600,
            fontWeight: 600,
            fontSize: "0.875rem",
            mb: 1,
            "&.Mui-focused": {
              color: color === "secondary" 
                ? theme.palette.secondary.main 
                : theme.palette.primary.main,
            },
            "&.Mui-error": {
              color: theme.palette.error.main,
            },
          }}
        >
          {label}
        </FormLabel>
      )}
      <RadioGroup
        value={value}
        onChange={onChange}
        row={row}
        sx={{
          gap: row ? 2 : 0.5,
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={option.disabled || disabled}
            control={
              <Radio
                color={color}
                size={size}
                sx={{
                  "&.Mui-checked": {
                    color: color === "secondary" 
                      ? theme.palette.secondary.main 
                      : theme.palette.primary.main,
                  },
                  "&:hover": {
                    backgroundColor: color === "secondary" 
                      ? `${theme.palette.secondary.main}08` 
                      : `${theme.palette.primary.main}08`,
                  },
                }}
              />
            }
            label={
              <Typography
                variant="body2"
                color={option.disabled || disabled ? "gray.g400" : "gray.g700"}
                sx={{
                  userSelect: "none",
                  fontSize: size === "small" ? "0.8rem" : "0.875rem",
                }}
              >
                {option.label}
              </Typography>
            }
            sx={{
              margin: 0,
              alignItems: "flex-start",
            }}
          />
        ))}
      </RadioGroup>
      {helperText && (
        <FormHelperText sx={{ mt: 0.5 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default AutobiaRadio;